"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parallax = void 0;
const parallax = () => {
    function debounce(func, wait = 100) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                func.apply(this, args);
            }, wait);
        };
    }
    let viewportWidth;
    let setViewportWidth = function () {
        viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    };
    let onResize = function () {
        if (viewportWidth > 768) {
            const wrappers = document.querySelectorAll('.parallax');
            wrappers.forEach((wrapper) => {
                scroller(wrapper);
                window.addEventListener('load', function (event) {
                    scroller(wrapper);
                });
                document.addEventListener('scroll', function (event) {
                    scroller(wrapper);
                });
                function scroller(wrapper) {
                    let initialOffset;
                    if (viewportWidth < 1024) {
                        initialOffset = 106;
                    }
                    else {
                        initialOffset = 151;
                    }
                    let items = wrapper.querySelectorAll('.parallax__item');
                    let scrollY = window.scrollY;
                    let windowHeight = window.innerHeight;
                    let scrollPosition = scrollY + (windowHeight * 3);
                    let elementTop = wrapper.getBoundingClientRect().top - initialOffset;
                    let elementPosition = elementTop + scrollY;
                    if (scrollPosition > elementPosition) {
                        items.forEach((shape) => {
                            shape.style.transform = 'translateY(' + elementTop / 4 + 'px)';
                        });
                    }
                }
            });
        }
        else {
            let shapes = document.querySelectorAll('.parallax__item');
            shapes.forEach((shape) => {
                shape.removeAttribute('style');
            });
        }
    };
    setViewportWidth();
    onResize();
    window.addEventListener('resize', function () {
        debounce(setViewportWidth(), 500);
        debounce(onResize(), 500);
    }, false);
};
exports.parallax = parallax;
